import React from "react";

const DollarIcon = ({ style, color }: { color?: string; style?: React.CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <svg
      style={{ ...style }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 14.6667C11.682 14.6667 14.6666 11.682 14.6666 7.99999C14.6666 4.31799 11.682 1.33333 7.99998 1.33333C4.31798 1.33333 1.33331 4.31799 1.33331 7.99999C1.33331 11.682 4.31798 14.6667 7.99998 14.6667Z"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 5.66666C9.54333 5.20999 8.73933 4.89266 8 4.87266M6 9.99999C6.42933 10.5733 7.22867 10.9 8 10.9273M8 4.87266C7.12 4.84866 6.33333 5.24666 6.33333 6.33332C6.33333 8.33332 10 7.33332 10 9.33332C10 10.474 9.024 10.964 8 10.9273M8 4.87266V3.66666M8 10.9273V12.3333"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DollarIcon;
